import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconHome: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill || '#262626';
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 3C14.7909 3 13 4.79086 13 7C13 9.20914 14.7909 11 17 11C19.2091 11 21 9.20914 21 7C21 4.79086 19.2091 3 17 3ZM3 17C3 14.7909 4.79086 13 7 13C9.20914 13 11 14.7909 11 17C11 19.2091 9.20914 21 7 21C4.79086 21 3 19.2091 3 17ZM13 14C13 13.4477 13.4477 13 14 13H20C20.5523 13 21 13.4477 21 14V19C21 20.1046 20.1046 21 19 21H15C13.8954 21 13 20.1046 13 19V14ZM3 4C3 3.44772 3.44772 3 4 3H10C10.5523 3 11 3.44772 11 4V9C11 10.1046 10.1046 11 9 11H5C3.89543 11 3 10.1046 3 9V4Z"
        fill={fill}
      />
    </Icon>
  );
};

export default IconHome;
